<template lang="pug">
  v-content
    EmergencyErrorDialog
    v-container(fluid grid-list-md)
      v-layout
        v-flex(md12)
          v-card
            v-card-text
              BillingStatementFilterConditions(ref="BillingStatementFilterConditions" @onChangeSearchConditions="onChangeSearchConditions")
            v-card-text
              v-layout(fluid)
                v-flex(xs12)
                  v-btn(@click="exportConfirm(exportType.sendUrl)" color="info" :loading="loading.export" :disabled="isDeselectedAll || !searchCond.onlyFaxTarget || !isTemporaryConfirmed") {{ exportType.sendLabel }}
                  v-btn(@click="exportConfirm(exportType.downloadUrl)" color="info" :loading="loading.export" :disabled="isDeselectedAll") {{ exportType.downloadLabel }}
                  v-btn(@click="exportConfirm(exportType.sendMailUrl)" color="info" :loading="loading.export" :disabled="isDeselectedAll") {{ exportType.sendMailLabel }}
                  ProgressBar
                  ExportConfirmDialog(ref="ExportConfirmDialog" :message="confirmMessage" @yes="exportReport")
      v-layout
        v-flex(xs12)
          v-card
            BillingStatementListTable(ref="BillingStatementListTable" @onChangeSearchConditions="onChangeSearchConditions")
</template>

<script>
import { mapGetters } from "vuex";
import EventDispatcher from "@/mixin/EventDispatcher";
import ExportHandler from "@/mixin/ExportHandler";
import EmergencyErrorDialog from "@/components/common/EmergencyErrorDialog";
import ExportConfirmDialog from "@/components/common/dialog/ExportConfirmDialog";
import BillingStatementFilterConditions from "@/components/report/BillingStatementFilterConditions";
import BillingStatementListTable from "@/components/report/BillingStatementListTable";
import ProgressBar from "@/components/common/ProgressBar";
import * as Enum from "@/assets/js/enum";

export default {
  components: {
    BillingStatementListTable,
    BillingStatementFilterConditions,
    EmergencyErrorDialog,
    ExportConfirmDialog,
    ProgressBar
  },
  mixins: [EventDispatcher, ExportHandler],
  data: () => ({
    // 検索エラーフラグ
    isError: false,
    confirmMessage: "現在の選択内容を出力しますか？",
    // ExportHandler処理用Store URL
    dispatchUrl: "",
    exportType: {
      downloadLabel: "請求書ダウンロード",
      sendLabel: "請求書送信(FAX)",
      sendMailLabel: "請求書送信(メール)",
      downloadUrl: "statement/downloadBillingStatement",
      sendUrl: "statement/sendBillingStatement",
      sendMailUrl: "statement/sendMailBillingStatement"
    }
  }),
  computed: {
    /** Getter：Vuex */
    ...mapGetters({
      isDeselectedAll: "statement/getIsDeselectedAll"
    }),
    isTemporaryConfirmed: {
      get() {
        return Enum.BillingStatusType.TEMPORARY_CONFIRMED.code === this.searchCond.billingStatus;
      }
    }
  },
  methods: {
    /**
     * Event：検索条件 変更
     */
    onChangeSearchConditions(searchCondition) {
      // ExportHandler条件設定
      this.searchCond = searchCondition;
      // InfiniteScrollHandler処理
      this.$refs.BillingStatementListTable.setSearchConditions(searchCondition);
      this.$refs.BillingStatementListTable.resetPageCount();
      this.$refs.BillingStatementListTable.resetAllSelect();
      // データ取得
      this.$refs.BillingStatementListTable.loadData()
        .then(result => (this.isError = false))
        .catch(error => {
          this.isError = true;
          // alertBox表示
          this.$refs.BillingStatementFilterConditions.displayMessage(error.response.data.message);
        });
    },
    /**
     * Event：出力ダイアログの表示
     * ※PDFダウンロード
     */
    exportConfirm(url) {
      this.$refs.BillingStatementFilterConditions.nonDisplayMessage();
      if (this.isError) return;
      this.dispatchUrl = url;
      this.$refs.ExportConfirmDialog.openDialog();
    },
    exportReport() {
      this.exportData(this.dispatchUrl).then(() => {
        this.$refs.BillingStatementFilterConditions.submit();
      });
    }
  },
  mounted() {
    // 初期ロード時に初期検索情報にて結果を表示
    this.$store.dispatch("statement/clearFetchList");
    this.$refs.BillingStatementFilterConditions.submit();
  }
};
</script>
